import React, { PropsWithChildren, useCallback } from 'react';
import { ErrorMessage, FieldProps } from 'formik';
import { FileUpload } from '@sdir/sds';
import { InputError } from '../Atoms';

interface FormFileUploadProps extends FieldProps {
  label: string;
  allowedTypes: string;
  className?: string;
  disabled?: boolean;
  onCallback?: (file: File[] | null) => void;
  multiple?: boolean;
}

function FormFileUpload({
  className,
  disabled,
  field,
  form,
  label,
  allowedTypes,
  onCallback,
  multiple = false,
}: PropsWithChildren<FormFileUploadProps>): React.ReactElement {
  const handleFilesSelected = useCallback(
    (files: File[]) => {
      form.setFieldValue(field.name, multiple ? files : files[0]);
      onCallback?.(files);
    },
    [form, field.name, multiple, onCallback]
  );

  return (
    <div className={className}>
      <FileUpload
        {...field}
        allowedTypes={allowedTypes}
        buttonLabel={label}
        onFilesSelected={handleFilesSelected}
        name={field.name}
      />
      {!disabled && <ErrorMessage name={field.name} component={InputError} />}
    </div>
  );
}

export default FormFileUpload;
